import React, { useContext, useEffect, useState } from "react";
import Button from "../../shared/button/Button";
import { businessCardLeft, leaveBusinessCard } from "../../../context/stands/action";
import { useSelector } from "react-redux";
import { AuthState } from "../../../context/auth/auth/reducer";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: any;
  disabled?: boolean;
}

const LeaveBusinessCardButton = ({ stand, disabled, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [alreadyLeft, setAlreadyLeft] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  const checkBusinessCardLeft = async () => {
    try {
      let left = await businessCardLeft(user?.uid, stand.id);
      setAlreadyLeft(left);
    } catch (err) {
      openToast({
        type: "error",
        title: "errors.general.title",
        callback: () => {},
      });
      setAlreadyLeft(false);
    } finally {
      setVisible(true);
    }
  };

  /**
   * Send business card, add record to db
   * @function
   * @async
   */
  const send = async () => {
    if (alreadyLeft || loading || !user) {
      return;
    }

    setLoading(true);

    try {
      await leaveBusinessCard(stand, user);
      setAlreadyLeft(true);
      openToast({
        type: "success",
        title: "success.general.title",
        message: "success.business_card_left",
        callback: () => {},
      });
    } catch (err) {
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        callback: () => {},
      });
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[LeaveBusinessCardButton] init");

    checkBusinessCardLeft();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[LeaveBusinessCardButton] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {!!visible && (
        <Button
          className={`btn btn-info ${alreadyLeft ? "btn-outline" : ""}`}
          onClick={send}
          disabled={loading}
        >
          {/* Can leave */}
          {!alreadyLeft && (
            <>
              {t("pages.standDetail.leave_business_card")} <i className="fas fa-address-card"></i>
            </>
          )}

          {/* Done */}
          {!!alreadyLeft && (
            <>
              {t("pages.standDetail.leave_business_card_done")} <i className="fas fa-check"></i>
            </>
          )}
        </Button>
      )}
    </>
  );
};
export default LeaveBusinessCardButton;
